document.addEventListener('DOMContentLoaded', function () {

  const menuItems = document.querySelectorAll(
    '.drawer__submenu-first-item'
  );

  menuItems.forEach(function (item, index) {

    const link = item.querySelector(
      ':scope > .drawer__submenu-link'
    );

    const submenu = item.querySelector(
      ':scope > .drawer__submenu-second'
    );

    /* Si no tiene submenú, no hacemos nada */
    if (!link || !submenu) return;


    /* Evita crear el botón dos veces */
    if (
      item.querySelector(
        ':scope > .lps-submenu-toggle'
      )
    ) {
      return;
    }


    /* ID accesible para relacionar botón y submenú */
    if (!submenu.id) {
      submenu.id =
        'lps-mobile-submenu-' + index;
    }


    /* Cerrado por defecto */
    submenu.hidden = true;

    const button = document.createElement('button');

    button.type = 'button';

    button.className =
      'lps-submenu-toggle';

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    button.setAttribute(
      'aria-controls',
      submenu.id
    );

    button.setAttribute(
      'aria-label',
      'Mostrar subcategorías de ' +
      link.textContent.trim()
    );


    const icon = document.createElement('span');

    icon.setAttribute(
      'aria-hidden',
      'true'
    );

    button.appendChild(icon);

    link.insertAdjacentElement(
      'afterend',
      button
    );


    button.addEventListener(
      'click',
      function () {

        const willOpen =
          !item.classList.contains('is-open');


        /*
         * Cerramos los demás del mismo bloque.
         * Así el menú nunca se hace excesivamente largo.
         */
        const parentList = item.parentElement;

        if (parentList) {

          Array.from(
            parentList.children
          ).forEach(function (sibling) {

            if (
              sibling === item ||
              !sibling.classList.contains(
                'drawer__submenu-first-item'
              )
            ) {
              return;
            }

            sibling.classList.remove(
              'is-open'
            );

            const siblingSubmenu =
              sibling.querySelector(
                ':scope > .drawer__submenu-second'
              );

            const siblingButton =
              sibling.querySelector(
                ':scope > .lps-submenu-toggle'
              );

            if (siblingSubmenu) {
              siblingSubmenu.hidden = true;
            }

            if (siblingButton) {

              siblingButton.setAttribute(
                'aria-expanded',
                'false'
              );

            }

          });

        }


        /* Abrir / cerrar el seleccionado */

        item.classList.toggle(
          'is-open',
          willOpen
        );

        submenu.hidden =
          !willOpen;

        button.setAttribute(
          'aria-expanded',
          String(willOpen)
        );

      }
    );

  });


  /*
   * Activamos el CSS del acordeón solo cuando
   * sabemos que los botones funcionan.
   */
  document.documentElement.classList.add(
    'lps-mobile-menu-ready'
  );

});